import React, {Component} from 'react';
import languages from './languages.json';

class LanguageCodes extends Component {

    constructor(props) {
        super(props);

        this.state = {
            langs: [],
            title: ''
        }
    }

    componentDidMount () {
        window.scrollTo(0, 0)

        let langs = [];
        if (this.props.match && this.props.match.params && this.props.match.params.codes) {
            let codes = this.props.match.params.codes.split(',');
            codes.forEach((code) => {
                let results = languages.filter((entry) => { return entry.code === code; })
                if (results) {
                    langs = langs.concat(results);
                }
            })
        } else {
            langs = languages;
        }

        this.setState({
            langs,
            title: this.props.match && this.props.match.params && this.props.match.params.title ? this.props.match.params.title : 'Supported Languages for Language Detection'
        })
    }

    render() {
        return (
            <div className="component-wrapper">
                <div className="flex-row">
                    <div className="flex-column">
                        <div className='list-table-title'>
                            <h1>{this.state.title}</h1>
                        </div>
                        <div className='list-table'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>Code</th>
                                        <th>Description</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {this.state.langs.map((lang) =>
                                    <tr key={lang.code}>
                                        <td>{lang.code}</td>
                                        <td>{lang.description}</td>
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

export default LanguageCodes;